module.exports = __webpack_public_path__ + "assets/on-maintainance.7181a04a.svg";